// ─────────────────────────────────────────────────────────────────────────────
// ga.js – Google Analytics 4 loader
//
// GDPR compliance:
//  - Skript sa NIKDY nenahrá pred explicitným súhlasom používateľa.
//  - IP anonymizácia je povinná pre EU (anonymize_ip: true).
//  - Pri odvolaní súhlasu sa GA deaktivuje a GA cookies sa vymažú.
//  - Nastavte REACT_APP_GA_ID v .env súbore (napr. G-XXXXXXXXXX).
// ─────────────────────────────────────────────────────────────────────────────

const GA_ID = process.env.REACT_APP_GA_ID;

let initialized = false;

/**
 * Dynamicky injektuje GA4 skript a inicializuje sledovanie.
 * Volajte VÝHRADNE po získaní analytics súhlasu.
 */
export function initGA() {
  if (initialized || !GA_ID) return;

  // Dynamické načítanie – skript sa nikdy neprednahrá
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    // Povinné pre GDPR – anonymizuje poslednú časť IP adresy
    anonymize_ip: true,
    // Manuálne riadime page views (napr. cez React Router)
    send_page_view: false,
  });

  initialized = true;
}

/**
 * Deaktivuje GA sledovanie a vymaže GA cookies.
 * Volajte pri odvolaní analytics súhlasu.
 */
export function revokeGA() {
  if (!GA_ID) return;

  // Oficiálny GA4 spôsob deaktivácie
  window[`ga-disable-${GA_ID}`] = true;
  initialized = false;

  // Vymazanie GA cookies pre aktuálnu doménu aj subdomény
  const cookieNames = [
    "_ga",
    `_ga_${GA_ID.replace("G-", "")}`,
    "_gid",
    "_gat",
  ];

  cookieNames.forEach((name) => {
    // Skúsime vymazať pre doménu aj subdomény
    const domain = window.location.hostname;
    const rootDomain = domain.split(".").slice(-2).join(".");

    [domain, `.${domain}`, `.${rootDomain}`].forEach((d) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${d}`;
    });
  });
}

/**
 * Odošle manuálny page view (napr. pri navigácii v SPA).
 * Bezpečné zavolanie – nič neurobí ak GA nie je inicializované.
 *
 * @param {string} path - napr. "/rozvrh"
 */
export function trackPageView(path) {
  if (!initialized || !window.gtag || !GA_ID) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
  });
}

/**
 * Odošle vlastnú udalosť.
 * Bezpečné – nič neurobí ak GA nie je inicializované.
 *
 * @param {string} eventName
 * @param {Record<string, unknown>} [params]
 */
export function trackEvent(eventName, params = {}) {
  if (!initialized || !window.gtag) return;
  window.gtag("event", eventName, params);
}
